import { render } from "./contrat-form.vue?vue&type=template&id=132b914e"
import script from "./contrat-form.vue?vue&type=script&lang=js"
export * from "./contrat-form.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__